import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { base_url } from '../Api/Api';
import { Popup } from '../Global/Popup';
import { Loader } from '../Global/Loader';

const Enterphone = (props) => {

    const [loading, setLoading] = useState(false)
    const [state, setState] = useState({
        temp: 0,
        loading: false,
        validNumber: false,
        loader: false,
        phoneNumber: null,
        verficcationText: '',
        statusDisAccount: false
    });

    useEffect(() => {

        checkStatus()

        setTimeout(() => {
            document.getElementById('enterPhone').classList.add('active')
        }, 300);

    }, [])

    const checkStatus = () => {

        if (localStorage.getItem('isVerfy')) {
            console.log('if')

            window.history.pushState(null, null, window.location.href);
            window.onpopstate = function () {
                window.history.go(1);
            };

            base_url.get("splash")
                .then(response => {
                    if (response.data.is_verify == 1) {
                        setState({
                            ...state,
                            loader: false,
                            statusDisAccount: false
                        })
                    } else {
                        setTimeout(() => {
                            setState({
                                ...state,
                                loader: false,
                                verficcationText: response.data.unverified_message,
                                statusDisAccount: true
                            })
                        }, 300);
                    }
                })
                .catch(error => {
                    localStorage.clear()
                    props.history.push(`/Entrance`)
                })
        } else if (localStorage.getItem('logined') !== null) {
            props.history.push(`/`)
        }
    }

    const handlePhoneNumber = (e) => {
        let target = e.currentTarget;
        if (target.value.length == 12) {
            target.value = target.value.slice(0, target.value.length - 1)
        }
        setState({
            ...state,
            phoneNumber: e.target.value,
            validNumber: false
        })
    }

    const contniue = () => {
        if ((/^(\+98|0)?9\d{9}$/).test(state.phoneNumber)) {
            localStorage.setItem('phoneNumber', JSON.stringify(state.phoneNumber));
            setState({
                ...state,
                validNumber: false,
                loader: true
            })
            const Data = {
                'mobile': state.phoneNumber,
            };
            const headers = {
                "Authorization": '',
                "content-type": "application/json",
            };
            base_url.post("registerOrLogin", Data, {
                headers: headers
            })
                .then(response => {
                    setState({
                        ...state,
                        loader: false
                    })
                    props.history.push('/Entrance/step2')
                })
                .catch(error => {
                    console.log(error.response)
                })
        } else {
            setState({
                ...state,
                validNumber: true
            })
        }
    }

    return (
        <div id="enterPhone" className={`entrnc-base enterphone`}>
            <Loader
                active={state.loader} />
            <Popup
                active={state.statusDisAccount}>
                <div className="disable-account">
                    <i className="icon-bell-fill"></i>
                    <h4>{state.verficcationText}</h4>
                    <div className="btn-base btn-black btn-sircle">
                        <Button
                            variant="contained"
                            onClick={() => {
                                window.close()
                            }} >خروج</Button>
                    </div>
                </div>
            </Popup>

            <div className="titles-style-1">
                <h4>ورود / ثبت نام</h4>
            </div>
            <div className="bx-info">
                <i className="icon-Group-4044"></i>
                <div className="input-form">
                    <TextField
                        id="standard-basic"
                        label="شماره موبایل خود را وارد کنید"
                        onChange={(e) => handlePhoneNumber(e)}
                    />
                    <span className={`error-respns ${state.validNumber ? 'active' : ''}`}>
                        <i className="icon-exclamation-mark"></i>
                        شماره موبایل را بصورت صحیح  و کامل وارد کنید
                    </span>
                </div>
                <div className="btn-base btn-black btn-sircle">
                    <Button
                        variant="contained"
                        onClick={contniue}>
                        ادامه
                    </Button>
                </div>
            </div>

        </div>
    );
}

export default withRouter(Enterphone);